module.exports = __webpack_public_path__ + "imgs/worldclass_sm.2c790446.webp";